export const spacer = '1rem';
export const white = '#fff';
export const gray100 = '#f8f9fa';
export const gray200 = '#e9ecef';
export const gray300 = '#dee2e6';
export const gray400 = '#ced4da';
export const gray500 = '#adb5bd';
export const gray600 = '#6c757d';
export const gray700 = '#495057';
export const gray800 = '#343a40';
export const gray900 = '#212529';
export const black = '#000';
export const blue = '#007bff';
export const indigo = '#6610f2';
export const purple = '#6f42c1';
export const pink = '#e83e8c';
export const red = '#dc3545';
export const orange = '#fd7e14';
export const yellow = '#ffc107';
export const green = '#28a745';
export const teal = '#20c997';
export const cyan = '#17a2b8';
export const biggbyOrange = '#f47920';
export const biggbyTeal = '#30cad6';
export const biggbyGreen = '#a2d55c';
export const biggbyPurple = '#74489d';
export const biggbyCyan = '#00aeef';
export const lightBiggbyOrange = '#faa21b';
export const lightenedBiggbyOrange = '#f78a3b';
export const gray = '#575757';
export const colors = {
	White: '#ffffff',
	Gray: gray,
	Black: '#020202',
	Red: '#db2828',
	Orange: '#f2711c',
	Yellow: '#fbbd08',
	Green: '#21ba45',
	Blue: '#2185d0',
	Purple: '#871f78',
	blue: blue,
	indigo: indigo,
	purple: purple,
	pink: pink,
	red: red,
	orange: orange,
	yellow: yellow,
	green: green,
	teal: teal,
	cyan: cyan,
	white: white,
	gray: gray400,
	grayDark: gray800
};
export const primary = biggbyOrange;
export const secondary = biggbyTeal;
export const success = biggbyGreen;
export const info = biggbyPurple;
export const warning = yellow;
export const danger = red;
export const light = gray100;
export const dark = gray800;
export const lightPrimary = lightBiggbyOrange;
export const lightenedPrimary = lightenedBiggbyOrange;
export const transparentPrimary = `rgba(${primary}, 0.25)`;
export const themeColors = {
	primary,
	secondary,
	success,
	info,
	warning,
	danger,
	light,
	dark,
	gray,
	lightPrimary,
	lightenedPrimary,
	transparentPrimary
};
export const themeColorInterval = '8%';
export const yiqContrastedThreshold = '150';
export const yiqTextDark = gray900;
export const yiqTextLight = white;
export const enableCaret = true;
export const enableRounded = true;
export const enableShadows = false;
export const enableGradients = false;
export const enableTransitions = true;
export const enablePrefersReducedMotionMediaQuery = true;
export const enableHoverMediaQuery = false;
export const enableGridClasses = true;
export const enablePointerCursorForButtons = true;
export const enablePrintStyles = true;
export const enableResponsiveFontSizes = true;
export const enableValidationIcons = true;
export const enableDeprecationMessages = true;
export const bodyBg = white;
export const bodyColor = gray900;
export const linkColor = primary;
export const linkDecoration = 'none';
export const linkHoverColor = `darken(${linkColor}, 15%)`;
export const linkHoverDecoration = 'underline';
export const emphasizedLinkHoverDarkenPercentage = '15%';
export const paragraphMarginBottom = '1rem';
export const gridBreakpoints = {
	xxxs: '0',
	xxs: '250px',
	xms: '319px',
	xs: '350px',
	ms: '400px',
	s: '480px',
	sm: '576px',
	md: '768px',
	lg: '992px',
	xl: '1200px'
};
export const containerMaxWidths = {
	sm: '540px',
	md: '720px',
	lg: '960px',
	xl: '1140px'
};
export const gridColumns = '12';
export const gridGutterWidth = '30px';
export const lineHeightLg = '1.5';
export const lineHeightSm = '1.5';
export const borderWidth = '1px';
export const borderColor = gray300;
export const borderRadius = '0.25rem';
export const borderRadiusLg = '0.3rem';
export const borderRadiusSm = '0.2rem';
export const roundedPill = '50rem';
export const boxShadowSm = `0 0.125rem 0.25rem rgba(${black}, 0.075)`;
export const boxShadow = `0 0.5rem 1rem rgba(${black}, 0.15)`;
export const boxShadowLg = `0 1rem 3rem rgba(${black}, 0.175)`;
export const componentActiveColor = white;
export const componentActiveBg = primary;
export const caretWidth = '0.3em';
export const caretVerticalAlign = `${caretWidth} * 0.85`;
export const caretSpacing = `${caretWidth} * 0.85`;
export const transitionBase = 'all 0.2s ease-in-out';
export const transitionFade = 'opacity 0.15s linear';
export const transitionCollapse = 'height 0.35s ease';
export const fontFamilySansSerif = "'Cera Round'";
export const fontFamilyMonospace =
	"SFMono-Regular, Menlo, Monaco, Consolas, 'Liberation Mono', 'Courier New', monospace";
export const fontFamilyBase = fontFamilySansSerif;
export const fontSizeBase = '1rem';
export const fontSizeLg = `${fontSizeBase} * 1.25`;
export const fontSizeSm = `${fontSizeBase} * 0.875`;
export const fontWeightLighter = 'lighter';
export const fontWeightLight = '300';
export const fontWeightNormal = '400';
export const fontWeightBold = '700';
export const fontWeightBolder = 'bolder';
export const fontWeightBase = fontWeightNormal;
export const lineHeightBase = '1.5';
export const h1FontSize = `${fontSizeBase} * 2.5`;
export const h2FontSize = `${fontSizeBase} * 2`;
export const h3FontSize = `${fontSizeBase} * 1.75`;
export const h4FontSize = `${fontSizeBase} * 1.5`;
export const h5FontSize = `${fontSizeBase} * 1.25`;
export const h6FontSize = fontSizeBase;
export const headingsMarginBottom = `${spacer} / 2`;
export const headingsFontFamily = 'null';
export const headingsFontWeight = '500';
export const headingsLineHeight = '1.2';
export const headingsColor = 'null';
export const display1Size = '6rem';
export const display2Size = '5.5rem';
export const display3Size = '4.5rem';
export const display4Size = '3.5rem';
export const display1Weight = '700';
export const display2Weight = '600';
export const display3Weight = '500';
export const display4Weight = '400';
export const displayLineHeight = headingsLineHeight;
export const leadFontSize = `${fontSizeBase} * 1.25`;
export const leadFontWeight = '300';
export const smallFontSize = '80%';
export const textMuted = gray600;
export const blockquoteSmallColor = gray600;
export const blockquoteSmallFontSize = smallFontSize;
export const blockquoteFontSize = `${fontSizeBase} * 1.25`;
export const hrBorderColor = `rgba(${black}, 0.1)`;
export const hrBorderWidth = borderWidth;
export const markPadding = '0.2em';
export const dtFontWeight = fontWeightBold;
export const kbdBoxShadow = `inset 0 -0.1rem 0 rgba(${black}, 0.25)`;
export const nestedKbdFontWeight = fontWeightBold;
export const listInlinePadding = '0.5rem';
export const markBg = '#fcf8e3';
export const hrMarginY = spacer;
export const tableCellPadding = '0.75rem';
export const tableCellPaddingSm = '0.3rem';
export const tableColor = bodyColor;
export const tableBg = 'null';
export const tableAccentBg = `rgba(${black}, 0.05)`;
export const tableHoverColor = tableColor;
export const tableHoverBg = `rgba(${black}, 0.075)`;
export const tableActiveBg = tableHoverBg;
export const tableBorderWidth = borderWidth;
export const tableBorderColor = borderColor;
export const tableHeadBg = gray200;
export const tableHeadColor = gray700;
export const tableDarkColor = white;
export const tableDarkBg = gray800;
export const tableDarkAccentBg = `rgba(${white}, 0.05)`;
export const tableDarkHoverColor = tableDarkColor;
export const tableDarkHoverBg = `rgba(${white}, 0.075)`;
export const tableDarkBorderColor = `lighten(${tableDarkBg}, 7.5%)`;
export const tableStripedOrder = 'odd';
export const tableCaptionColor = textMuted;
export const tableBgLevel = '-9';
export const tableBorderLevel = '-6';
export const inputBtnPaddingY = '0.375rem';
export const inputBtnPaddingX = '0.75rem';
export const inputBtnFontFamily = 'null';
export const inputBtnFontSize = fontSizeBase;
export const inputBtnLineHeight = lineHeightBase;
export const inputBtnFocusWidth = '0.2rem';
export const inputBtnFocusColor = `rgba(${componentActiveBg}, 0.25)`;
export const inputBtnFocusBoxShadow = `0 0 0 ${inputBtnFocusWidth} ${inputBtnFocusColor}`;
export const inputBtnPaddingYSm = '0.25rem';
export const inputBtnPaddingXSm = '0.5rem';
export const inputBtnFontSizeSm = fontSizeSm;
export const inputBtnLineHeightSm = lineHeightSm;
export const inputBtnPaddingYLg = '0.5rem';
export const inputBtnPaddingXLg = '1rem';
export const inputBtnFontSizeLg = fontSizeLg;
export const inputBtnLineHeightLg = lineHeightLg;
export const inputBtnBorderWidth = borderWidth;
export const btnPaddingY = inputBtnPaddingY;
export const btnPaddingX = inputBtnPaddingX;
export const btnFontFamily = inputBtnFontFamily;
export const btnFontSize = inputBtnFontSize;
export const btnLineHeight = inputBtnLineHeight;
export const btnPaddingYSm = inputBtnPaddingYSm;
export const btnPaddingXSm = inputBtnPaddingXSm;
export const btnFontSizeSm = inputBtnFontSizeSm;
export const btnLineHeightSm = inputBtnLineHeightSm;
export const btnPaddingYLg = inputBtnPaddingYLg;
export const btnPaddingXLg = inputBtnPaddingXLg;
export const btnFontSizeLg = inputBtnFontSizeLg;
export const btnLineHeightLg = inputBtnLineHeightLg;
export const btnBorderWidth = inputBtnBorderWidth;
export const btnFontWeight = fontWeightBold;
export const btnBoxShadow = `inset 0 1px 0 rgba(${white}, 0.15), 0 1px 1px rgba(${black}, 0.075)`;
export const btnFocusWidth = inputBtnFocusWidth;
export const btnFocusBoxShadow = inputBtnFocusBoxShadow;
export const btnDisabledOpacity = '0.65';
export const btnActiveBoxShadow = `inset 0 3px 5px rgba(${black}, 0.125)`;
export const btnLinkDisabledColor = gray600;
export const btnBlockSpacingY = '0.5rem';
export const btnBorderRadius = '1.5em';
export const btnBorderRadiusLg = '1.5em';
export const btnBorderRadiusSm = '1.5em';
export const btnTransition =
	'color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out';
export const labelMarginBottom = '0.5rem';
export const inputPaddingY = inputBtnPaddingY;
export const inputPaddingX = inputBtnPaddingX;
export const inputFontFamily = inputBtnFontFamily;
export const inputFontSize = inputBtnFontSize;
export const inputFontWeight = fontWeightBase;
export const inputLineHeight = inputBtnLineHeight;
export const inputPaddingYSm = inputBtnPaddingYSm;
export const inputPaddingXSm = inputBtnPaddingXSm;
export const inputFontSizeSm = inputBtnFontSizeSm;
export const inputLineHeightSm = inputBtnLineHeightSm;
export const inputPaddingYLg = inputBtnPaddingYLg;
export const inputPaddingXLg = inputBtnPaddingXLg;
export const inputFontSizeLg = inputBtnFontSizeLg;
export const inputLineHeightLg = inputBtnLineHeightLg;
export const inputBg = white;
export const inputDisabledBg = gray200;
export const inputColor = gray700;
export const inputBorderColor = gray400;
export const inputBorderWidth = inputBtnBorderWidth;
export const inputBoxShadow = `inset 0 1px 1px rgba(${black}, 0.075)`;
export const inputBorderRadius = '0';
export const inputBorderRadiusLg = '0';
export const inputBorderRadiusSm = '0';
export const inputFocusBg = inputBg;
export const inputFocusBorderColor = `lighten(${componentActiveBg}, 25%)`;
export const inputFocusColor = inputColor;
export const inputFocusWidth = inputBtnFocusWidth;
export const inputFocusBoxShadow = inputBtnFocusBoxShadow;
export const inputPlaceholderColor = gray600;
export const inputPlaintextColor = bodyColor;
export const inputHeightBorder = `${inputBorderWidth} * 2`;
export const inputHeightInner = `calc( ${inputLineHeight} * 1em + ${inputPaddingY} * 2 )`;
export const inputHeightInnerHalf = `calc( ${inputLineHeight} * 0.5em + ${inputPaddingY} )`;
export const inputHeightInnerQuarter = `calc( ${inputLineHeight} * 0.25em + ${inputPaddingY} / 2 )`;
export const inputHeight = `calc( ${inputLineHeight} * 1em + ${inputPaddingY} * 2 + ${inputHeightBorder} )`;
export const inputHeightSm = `calc( ${inputLineHeightSm} * 1em + ${inputBtnPaddingYSm} * 2 + ${inputHeightBorder} )`;
export const inputHeightLg = `calc( ${inputLineHeightLg} * 1em + ${inputBtnPaddingYLg} * 2 + ${inputHeightBorder} )`;
export const inputTransition =
	'border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out';
export const formTextMarginTop = '0.25rem';
export const formCheckInputGutter = '1.25rem';
export const formCheckInputMarginY = '0.3rem';
export const formCheckInputMarginX = '0.25rem';
export const formCheckInlineMarginX = '0.75rem';
export const formCheckInlineInputMarginX = '0.3125rem';
export const formGridGutterWidth = '10px';
export const formGroupMarginBottom = '1rem';
export const inputGroupAddonColor = inputColor;
export const inputGroupAddonBg = gray200;
export const inputGroupAddonBorderColor = inputBorderColor;
export const customFormsTransition =
	'background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out';
export const customControlGutter = '0.5rem';
export const customControlSpacerX = '1rem';
export const customControlIndicatorSize = '1rem';
export const customControlIndicatorBg = inputBg;
export const customControlIndicatorBgSize = '50% 50%';
export const customControlIndicatorBoxShadow = inputBoxShadow;
export const customControlIndicatorBorderColor = gray500;
export const customControlIndicatorBorderWidth = inputBorderWidth;
export const customControlIndicatorDisabledBg = inputDisabledBg;
export const customControlLabelDisabledColor = gray600;
export const customControlIndicatorCheckedColor = componentActiveColor;
export const customControlIndicatorCheckedBg = componentActiveBg;
export const customControlIndicatorCheckedDisabledBg = `rgba(${primary}, 0.5)`;
export const customControlIndicatorCheckedBoxShadow = 'none';
export const customControlIndicatorCheckedBorderColor =
	customControlIndicatorCheckedBg;
export const customControlIndicatorFocusBoxShadow = inputFocusBoxShadow;
export const customControlIndicatorFocusBorderColor = inputFocusBorderColor;
export const customControlIndicatorActiveColor = componentActiveColor;
export const customControlIndicatorActiveBg = `lighten( ${componentActiveBg}, 35% )`;
export const customControlIndicatorActiveBoxShadow = 'none';
export const customControlIndicatorActiveBorderColor =
	customControlIndicatorActiveBg;
export const customCheckboxIndicatorBorderRadius = borderRadius;
export const customCheckboxIndicatorIndeterminateBg = componentActiveBg;
export const customCheckboxIndicatorIndeterminateColor =
	customControlIndicatorCheckedColor;
export const customCheckboxIndicatorIndeterminateBoxShadow = 'none';
export const customCheckboxIndicatorIndeterminateBorderColor =
	customCheckboxIndicatorIndeterminateBg;
export const customRadioIndicatorBorderRadius = '50%';
export const customSwitchWidth = `${customControlIndicatorSize} * 1.75`;
export const customSwitchIndicatorBorderRadius = `${customControlIndicatorSize} / 2`;
export const customSwitchIndicatorSize = `calc( ${customControlIndicatorSize} - ${customControlIndicatorBorderWidth} * 4} )`;
export const customSelectPaddingY = inputPaddingY;
export const customSelectPaddingX = inputPaddingX;
export const customSelectFontFamily = inputFontFamily;
export const customSelectFontSize = inputFontSize;
export const customSelectHeight = inputHeight;
export const customSelectIndicatorPadding = '1rem';
export const customSelectFontWeight = inputFontWeight;
export const customSelectLineHeight = inputLineHeight;
export const customSelectColor = inputColor;
export const customSelectDisabledColor = gray600;
export const customSelectBg = inputBg;
export const customSelectDisabledBg = gray200;
export const customSelectBgSize = '8px 10px';
export const customSelectIndicatorColor = gray800;
export const customSelectFeedbackIconPaddingRight = `calc( (1em + 2 * ${customSelectPaddingY}) * 3 / 4 + ${customSelectPaddingX} + ${customSelectIndicatorPadding} )`;
export const customSelectFeedbackIconPosition = `center right (${customSelectPaddingX} + ${customSelectIndicatorPadding})`;
export const customSelectFeedbackIconSize = `${inputHeightInnerHalf} ${inputHeightInnerHalf}`;
export const customSelectBorderWidth = inputBorderWidth;
export const customSelectBorderColor = inputBorderColor;
export const customSelectBorderRadius = borderRadius;
export const customSelectBoxShadow = `inset 0 1px 2px rgba(${black}, 0.075)`;
export const customSelectFocusBorderColor = inputFocusBorderColor;
export const customSelectFocusWidth = inputFocusWidth;
export const customSelectFocusBoxShadow = `0 0 0 ${customSelectFocusWidth} ${inputBtnFocusColor}`;
export const customSelectPaddingYSm = inputPaddingYSm;
export const customSelectPaddingXSm = inputPaddingXSm;
export const customSelectFontSizeSm = inputFontSizeSm;
export const customSelectHeightSm = inputHeightSm;
export const customSelectPaddingYLg = inputPaddingYLg;
export const customSelectPaddingXLg = inputPaddingXLg;
export const customSelectFontSizeLg = inputFontSizeLg;
export const customSelectHeightLg = inputHeightLg;
export const customRangeTrackWidth = '100%';
export const customRangeTrackHeight = '0.5rem';
export const customRangeTrackCursor = 'pointer';
export const customRangeTrackBg = gray300;
export const customRangeTrackBorderRadius = '1rem';
export const customRangeTrackBoxShadow = `inset 0 0.25rem 0.25rem rgba(${black}, 0.1)`;
export const customRangeThumbWidth = '1rem';
export const customRangeThumbHeight = customRangeThumbWidth;
export const customRangeThumbBg = componentActiveBg;
export const customRangeThumbBorder = '0';
export const customRangeThumbBorderRadius = '1rem';
export const customRangeThumbBoxShadow = `0 0.1rem 0.25rem rgba(${black}, 0.1)`;
export const customRangeThumbFocusBoxShadow = `0 0 0 1px ${bodyBg}, ${inputFocusBoxShadow}`;
export const customRangeThumbFocusBoxShadowWidth = inputFocusWidth;
export const customRangeThumbActiveBg = `lighten(${componentActiveBg}, 35%)`;
export const customRangeThumbDisabledBg = gray500;
export const customFileHeight = inputHeight;
export const customFileHeightInner = inputHeightInner;
export const customFileFocusBorderColor = inputFocusBorderColor;
export const customFileFocusBoxShadow = inputFocusBoxShadow;
export const customFileDisabledBg = inputDisabledBg;
export const customFilePaddingY = inputPaddingY;
export const customFilePaddingX = inputPaddingX;
export const customFileLineHeight = inputLineHeight;
export const customFileFontFamily = inputFontFamily;
export const customFileFontWeight = inputFontWeight;
export const customFileColor = inputColor;
export const customFileBg = inputBg;
export const customFileBorderWidth = inputBorderWidth;
export const customFileBorderColor = inputBorderColor;
export const customFileBorderRadius = inputBorderRadius;
export const customFileBoxShadow = inputBoxShadow;
export const customFileButtonColor = customFileColor;
export const customFileButtonBg = inputGroupAddonBg;
export const customFileText = { en: '"Browse"' };
export const formFeedbackMarginTop = formTextMarginTop;
export const formFeedbackFontSize = smallFontSize;
export const formFeedbackValidColor = success;
export const formFeedbackInvalidColor = danger;
export const formFeedbackIconValidColor = formFeedbackValidColor;
export const formFeedbackIconInvalidColor = formFeedbackInvalidColor;
export const zindexDropdown = '1000';
export const zindexSticky = '1020';
export const zindexFixed = '1030';
export const zindexModalBackdrop = '1040';
export const zindexModal = '1050';
export const zindexPopover = '1060';
export const zindexTooltip = '1070';
export const navLinkPaddingY = '0.5rem';
export const navLinkPaddingX = '1rem';
export const navLinkDisabledColor = gray600;
export const navTabsBorderColor = gray300;
export const navTabsBorderWidth = borderWidth;
export const navTabsBorderRadius = borderRadius;
export const navTabsLinkHoverBorderColor = `${gray200} ${gray200} ${navTabsBorderColor}`;
export const navTabsLinkActiveColor = gray700;
export const navTabsLinkActiveBg = bodyBg;
export const navTabsLinkActiveBorderColor = `${gray300} ${gray300} ${navTabsLinkActiveBg}`;
export const navPillsBorderRadius = borderRadius;
export const navPillsLinkActiveColor = componentActiveColor;
export const navPillsLinkActiveBg = componentActiveBg;
export const navDividerColor = gray200;
export const navDividerMarginY = `${spacer} / 2`;
export const navbarPaddingY = `${spacer} / 2`;
export const navbarPaddingX = spacer;
export const navbarNavLinkPaddingX = '0.5rem';
export const navbarBrandFontSize = fontSizeLg;
export const navLinkHeight = `${fontSizeBase} * ${lineHeightBase} + ${navLinkPaddingY} * 2`;
export const navbarBrandHeight = `${navbarBrandFontSize} * ${lineHeightBase}`;
export const navbarBrandPaddingY = `(${navLinkHeight} - ${navbarBrandHeight}) / 2`;
export const navbarTogglerPaddingY = '0.25rem';
export const navbarTogglerPaddingX = '0.75rem';
export const navbarTogglerFontSize = fontSizeLg;
export const navbarTogglerBorderRadius = btnBorderRadius;
export const navbarDarkColor = `rgba(${white}, 0.5)`;
export const navbarDarkHoverColor = `rgba(${white}, 0.75)`;
export const navbarDarkActiveColor = white;
export const navbarDarkDisabledColor = `rgba(${white}, 0.25)`;
export const navbarDarkTogglerBorderColor = `rgba(${white}, 0.1)`;
export const navbarLightColor = gray;
export const navbarLightHoverColor = primary;
export const navbarLightActiveColor = primary;
export const navbarLightDisabledColor = `rgba(${black}, 0.3)`;
export const navbarLightTogglerBorderColor = `rgba(${black}, 0.1)`;
export const navbarLightBrandColor = navbarLightActiveColor;
export const navbarLightBrandHoverColor = navbarLightActiveColor;
export const navbarDarkBrandColor = navbarDarkActiveColor;
export const navbarDarkBrandHoverColor = navbarDarkActiveColor;
export const dropdownMinWidth = '10rem';
export const dropdownPaddingY = '0';
export const dropdownSpacer = '0.125rem';
export const dropdownFontSize = fontSizeBase;
export const dropdownColor = bodyColor;
export const dropdownBg = white;
export const dropdownBorderColor = gray;
export const dropdownBorderRadius = '0';
export const dropdownBorderWidth = borderWidth;
export const dropdownInnerBorderRadius = '0';
export const dropdownDividerBg = gray;
export const dropdownDividerMarginY = '0';
export const dropdownBoxShadow = `0 0.5rem 1rem rgba(${black}, 0.175)`;
export const dropdownLinkColor = gray900;
export const dropdownLinkHoverColor = `darken(${gray900}, 5%)`;
export const dropdownLinkHoverBg = gray100;
export const dropdownLinkActiveColor = componentActiveColor;
export const dropdownLinkActiveBg = componentActiveBg;
export const dropdownLinkDisabledColor = gray600;
export const dropdownItemPaddingY = '0.5rem';
export const dropdownItemPaddingX = '1rem';
export const dropdownHeaderColor = gray600;
export const paginationPaddingY = '0.5rem';
export const paginationPaddingX = '0.75rem';
export const paginationPaddingYSm = '0.25rem';
export const paginationPaddingXSm = '0.5rem';
export const paginationPaddingYLg = '0.75rem';
export const paginationPaddingXLg = '1.5rem';
export const paginationLineHeight = '1.25';
export const paginationColor = linkColor;
export const paginationBg = white;
export const paginationBorderWidth = borderWidth;
export const paginationBorderColor = gray300;
export const paginationFocusBoxShadow = inputBtnFocusBoxShadow;
export const paginationFocusOutline = '0';
export const paginationHoverColor = linkHoverColor;
export const paginationHoverBg = gray200;
export const paginationHoverBorderColor = gray300;
export const paginationActiveColor = componentActiveColor;
export const paginationActiveBg = componentActiveBg;
export const paginationActiveBorderColor = paginationActiveBg;
export const paginationDisabledColor = gray600;
export const paginationDisabledBg = white;
export const paginationDisabledBorderColor = gray300;
export const jumbotronPadding = '2rem';
export const jumbotronColor = 'null';
export const jumbotronBg = gray200;
export const cardSpacerY = '0.75rem';
export const cardSpacerX = '1.25rem';
export const cardBorderWidth = borderWidth;
export const cardBorderRadius = borderRadius;
export const cardBorderColor = `rgba(${black}, 0.125)`;
export const cardInnerBorderRadius = `calc( ${cardBorderRadius} - ${cardBorderWidth} )`;
export const cardCapBg = `rgba(${black}, 0.03)`;
export const cardCapColor = 'null';
export const cardColor = 'null';
export const cardBg = white;
export const cardImgOverlayPadding = '1.25rem';
export const cardGroupMargin = `${gridGutterWidth} / 2`;
export const cardDeckMargin = cardGroupMargin;
export const cardColumnsCount = '3';
export const cardColumnsGap = '1.25rem';
export const cardColumnsMargin = cardSpacerY;
export const tooltipFontSize = fontSizeSm;
export const tooltipMaxWidth = '200px';
export const tooltipColor = white;
export const tooltipBg = black;
export const tooltipBorderRadius = borderRadius;
export const tooltipOpacity = '0.9';
export const tooltipPaddingY = '0.25rem';
export const tooltipPaddingX = '0.5rem';
export const tooltipMargin = '0';
export const tooltipArrowWidth = '0.8rem';
export const tooltipArrowHeight = '0.4rem';
export const tooltipArrowColor = tooltipBg;
export const formFeedbackTooltipPaddingY = tooltipPaddingY;
export const formFeedbackTooltipPaddingX = tooltipPaddingX;
export const formFeedbackTooltipFontSize = tooltipFontSize;
export const formFeedbackTooltipLineHeight = lineHeightBase;
export const formFeedbackTooltipOpacity = tooltipOpacity;
export const formFeedbackTooltipBorderRadius = tooltipBorderRadius;
export const popoverFontSize = fontSizeSm;
export const popoverBg = white;
export const popoverMaxWidth = '276px';
export const popoverBorderWidth = borderWidth;
export const popoverBorderColor = `rgba(${black}, 0.2)`;
export const popoverBorderRadius = borderRadiusLg;
export const popoverBoxShadow = `0 0.25rem 0.5rem rgba(${black}, 0.2)`;
export const popoverHeaderBg = `darken(${popoverBg}, 3%)`;
export const popoverHeaderColor = headingsColor;
export const popoverHeaderPaddingY = '0.5rem';
export const popoverHeaderPaddingX = '0.75rem';
export const popoverBodyColor = bodyColor;
export const popoverBodyPaddingY = popoverHeaderPaddingY;
export const popoverBodyPaddingX = popoverHeaderPaddingX;
export const popoverArrowWidth = '1rem';
export const popoverArrowHeight = '0.5rem';
export const popoverArrowColor = popoverBg;
export const popoverArrowOuterColor = `fade-in(${popoverBorderColor}, 0.05)`;
export const toastMaxWidth = '350px';
export const toastPaddingX = '0.75rem';
export const toastPaddingY = '0.25rem';
export const toastFontSize = '0.875rem';
export const toastColor = 'null';
export const toastBackgroundColor = `rgba(${white}, 0.85)`;
export const toastBorderWidth = '1px';
export const toastBorderColor = 'rgba(0, 0, 0, 0.1)';
export const toastBorderRadius = '0.25rem';
export const toastBoxShadow = `0 0.25rem 0.75rem rgba(${black}, 0.1)`;
export const toastHeaderColor = gray600;
export const toastHeaderBackgroundColor = `rgba(${white}, 0.85)`;
export const toastHeaderBorderColor = 'rgba(0, 0, 0, 0.05)';
export const badgeFontSize = '75%';
export const badgeFontWeight = fontWeightBold;
export const badgePaddingY = '0.25em';
export const badgePaddingX = '0.4em';
export const badgeBorderRadius = borderRadius;
export const badgeTransition = btnTransition;
export const badgeFocusWidth = inputBtnFocusWidth;
export const badgePillPaddingX = '0.6em';
export const badgePillBorderRadius = '10rem';
export const modalInnerPadding = '1rem';
export const modalDialogMargin = '0.5rem';
export const modalDialogMarginYSmUp = '1.75rem';
export const modalTitleLineHeight = lineHeightBase;
export const modalContentColor = 'null';
export const modalContentBg = white;
export const modalContentBorderColor = `rgba(${black}, 0.2)`;
export const modalContentBorderWidth = borderWidth;
export const modalContentBorderRadius = borderRadiusLg;
export const modalContentBoxShadowXs = `0 0.25rem 0.5rem rgba(${black}, 0.5)`;
export const modalContentBoxShadowSmUp = `0 0.5rem 1rem rgba(${black}, 0.5)`;
export const modalBackdropBg = black;
export const modalBackdropOpacity = '0.5';
export const modalHeaderBorderColor = borderColor;
export const modalFooterBorderColor = modalHeaderBorderColor;
export const modalHeaderBorderWidth = modalContentBorderWidth;
export const modalFooterBorderWidth = modalHeaderBorderWidth;
export const modalHeaderPaddingY = '1rem';
export const modalHeaderPaddingX = '1rem';
export const modalHeaderPadding = `${modalHeaderPaddingY} ${modalHeaderPaddingX}`;
export const modalXl = '1140px';
export const modalLg = '800px';
export const modalMd = '500px';
export const modalSm = '300px';
export const modalFadeTransform = 'translate(0, -50px)';
export const modalShowTransform = 'none';
export const modalTransition = 'transform 0.3s ease-out';
export const alertPaddingY = '0.75rem';
export const alertPaddingX = '1.25rem';
export const alertMarginBottom = '1rem';
export const alertBorderRadius = '0';
export const alertLinkFontWeight = fontWeightBold;
export const alertBorderWidth = borderWidth;
export const alertBgLevel = '-10';
export const alertBorderLevel = '-9';
export const alertColorLevel = '6';
export const progressHeight = '1rem';
export const progressFontSize = `${fontSizeBase} * 0.75`;
export const progressBg = gray200;
export const progressBorderRadius = borderRadius;
export const progressBoxShadow = `inset 0 0.1rem 0.1rem rgba(${black}, 0.1)`;
export const progressBarColor = white;
export const progressBarBg = primary;
export const progressBarAnimationTiming = '1s linear infinite';
export const progressBarTransition = 'width 0.6s ease';
export const listGroupColor = 'null';
export const listGroupBg = white;
export const listGroupBorderColor = `rgba(${black}, 0.125)`;
export const listGroupBorderWidth = borderWidth;
export const listGroupBorderRadius = borderRadius;
export const listGroupItemPaddingY = '0.75rem';
export const listGroupItemPaddingX = '1.25rem';
export const listGroupHoverBg = gray100;
export const listGroupActiveColor = componentActiveColor;
export const listGroupActiveBg = componentActiveBg;
export const listGroupActiveBorderColor = listGroupActiveBg;
export const listGroupDisabledColor = gray600;
export const listGroupDisabledBg = listGroupBg;
export const listGroupActionColor = gray700;
export const listGroupActionHoverColor = listGroupActionColor;
export const listGroupActionActiveColor = bodyColor;
export const listGroupActionActiveBg = gray200;
export const thumbnailPadding = '0.25rem';
export const thumbnailBg = bodyBg;
export const thumbnailBorderWidth = borderWidth;
export const thumbnailBorderColor = gray300;
export const thumbnailBorderRadius = borderRadius;
export const thumbnailBoxShadow = `0 1px 2px rgba(${black}, 0.075)`;
export const figureCaptionFontSize = '90%';
export const figureCaptionColor = gray600;
export const breadcrumbPaddingY = '0.75rem';
export const breadcrumbPaddingX = '1rem';
export const breadcrumbItemPadding = '0.5rem';
export const breadcrumbMarginBottom = '1rem';
export const breadcrumbBg = gray200;
export const breadcrumbDividerColor = gray600;
export const breadcrumbActiveColor = gray600;
export const breadcrumbDivider = '/';
export const breadcrumbBorderRadius = borderRadius;
export const spinnerWidth = '2rem';
export const spinnerHeight = spinnerWidth;
export const spinnerBorderWidth = '0.25em';
export const spinnerWidthSm = '1rem';
export const spinnerHeightSm = spinnerWidthSm;
export const spinnerBorderWidthSm = '0.2em';
export const closeFontSize = `${fontSizeBase} * 1.5`;
export const closeFontWeight = fontWeightBold;
export const closeColor = black;
export const closeTextShadow = `0 1px 0 ${white}`;
export const codeFontSize = '87.5%';
export const codeColor = pink;
export const kbdPaddingY = '0.2rem';
export const kbdPaddingX = '0.4rem';
export const kbdFontSize = codeFontSize;
export const kbdColor = white;
export const kbdBg = gray900;
export const preColor = gray900;
export const preScrollableMaxHeight = '340px';
export const displays =
	'none, inline, inline-block, block, table, table-row, table-cell, flex, inline-flex';
export const overflows = 'auto, hidden';
export const positions = 'static, relative, absolute, fixed, sticky';

export const web = {
	spacer,
	white,
	gray100,
	gray200,
	gray300,
	gray400,
	gray500,
	gray600,
	gray700,
	gray800,
	gray900,
	black,
	blue,
	indigo,
	purple,
	pink,
	red,
	orange,
	yellow,
	green,
	teal,
	cyan,
	biggbyOrange,
	biggbyTeal,
	biggbyGreen,
	biggbyPurple,
	biggbyCyan,
	lightBiggbyOrange,
	lightenedBiggbyOrange,
	gray,
	colors,
	primary,
	secondary,
	success,
	info,
	warning,
	danger,
	light,
	dark,
	lightPrimary,
	lightenedPrimary,
	transparentPrimary,
	themeColors,
	themeColorInterval,
	yiqContrastedThreshold,
	yiqTextDark,
	yiqTextLight,
	enableCaret,
	enableRounded,
	enableShadows,
	enableGradients,
	enableTransitions,
	enablePrefersReducedMotionMediaQuery,
	enableHoverMediaQuery,
	enableGridClasses,
	enablePointerCursorForButtons,
	enablePrintStyles,
	enableResponsiveFontSizes,
	enableValidationIcons,
	enableDeprecationMessages,
	bodyBg,
	bodyColor,
	linkColor,
	linkDecoration,
	linkHoverColor,
	linkHoverDecoration,
	emphasizedLinkHoverDarkenPercentage,
	paragraphMarginBottom,
	gridBreakpoints,
	containerMaxWidths,
	gridColumns,
	gridGutterWidth,
	lineHeightLg,
	lineHeightSm,
	borderWidth,
	borderColor,
	borderRadius,
	borderRadiusLg,
	borderRadiusSm,
	roundedPill,
	boxShadowSm,
	boxShadow,
	boxShadowLg,
	componentActiveColor,
	componentActiveBg,
	caretWidth,
	caretVerticalAlign,
	caretSpacing,
	transitionBase,
	transitionFade,
	transitionCollapse,
	fontFamilySansSerif,
	fontFamilyMonospace,
	fontFamilyBase,
	fontSizeBase,
	fontSizeLg,
	fontSizeSm,
	fontWeightLighter,
	fontWeightLight,
	fontWeightNormal,
	fontWeightBold,
	fontWeightBolder,
	fontWeightBase,
	lineHeightBase,
	h1FontSize,
	h2FontSize,
	h3FontSize,
	h4FontSize,
	h5FontSize,
	h6FontSize,
	headingsMarginBottom,
	headingsFontFamily,
	headingsFontWeight,
	headingsLineHeight,
	headingsColor,
	display1Size,
	display2Size,
	display3Size,
	display4Size,
	display1Weight,
	display2Weight,
	display3Weight,
	display4Weight,
	displayLineHeight,
	leadFontSize,
	leadFontWeight,
	smallFontSize,
	textMuted,
	blockquoteSmallColor,
	blockquoteSmallFontSize,
	blockquoteFontSize,
	hrBorderColor,
	hrBorderWidth,
	markPadding,
	dtFontWeight,
	kbdBoxShadow,
	nestedKbdFontWeight,
	listInlinePadding,
	markBg,
	hrMarginY,
	tableCellPadding,
	tableCellPaddingSm,
	tableColor,
	tableBg,
	tableAccentBg,
	tableHoverColor,
	tableHoverBg,
	tableActiveBg,
	tableBorderWidth,
	tableBorderColor,
	tableHeadBg,
	tableHeadColor,
	tableDarkColor,
	tableDarkBg,
	tableDarkAccentBg,
	tableDarkHoverColor,
	tableDarkHoverBg,
	tableDarkBorderColor,
	tableStripedOrder,
	tableCaptionColor,
	tableBgLevel,
	tableBorderLevel,
	inputBtnPaddingY,
	inputBtnPaddingX,
	inputBtnFontFamily,
	inputBtnFontSize,
	inputBtnLineHeight,
	inputBtnFocusWidth,
	inputBtnFocusColor,
	inputBtnFocusBoxShadow,
	inputBtnPaddingYSm,
	inputBtnPaddingXSm,
	inputBtnFontSizeSm,
	inputBtnLineHeightSm,
	inputBtnPaddingYLg,
	inputBtnPaddingXLg,
	inputBtnFontSizeLg,
	inputBtnLineHeightLg,
	inputBtnBorderWidth,
	btnPaddingY,
	btnPaddingX,
	btnFontFamily,
	btnFontSize,
	btnLineHeight,
	btnPaddingYSm,
	btnPaddingXSm,
	btnFontSizeSm,
	btnLineHeightSm,
	btnPaddingYLg,
	btnPaddingXLg,
	btnFontSizeLg,
	btnLineHeightLg,
	btnBorderWidth,
	btnFontWeight,
	btnBoxShadow,
	btnFocusWidth,
	btnFocusBoxShadow,
	btnDisabledOpacity,
	btnActiveBoxShadow,
	btnLinkDisabledColor,
	btnBlockSpacingY,
	btnBorderRadius,
	btnBorderRadiusLg,
	btnBorderRadiusSm,
	btnTransition,
	labelMarginBottom,
	inputPaddingY,
	inputPaddingX,
	inputFontFamily,
	inputFontSize,
	inputFontWeight,
	inputLineHeight,
	inputPaddingYSm,
	inputPaddingXSm,
	inputFontSizeSm,
	inputLineHeightSm,
	inputPaddingYLg,
	inputPaddingXLg,
	inputFontSizeLg,
	inputLineHeightLg,
	inputBg,
	inputDisabledBg,
	inputColor,
	inputBorderColor,
	inputBorderWidth,
	inputBoxShadow,
	inputBorderRadius,
	inputBorderRadiusLg,
	inputBorderRadiusSm,
	inputFocusBg,
	inputFocusBorderColor,
	inputFocusColor,
	inputFocusWidth,
	inputFocusBoxShadow,
	inputPlaceholderColor,
	inputPlaintextColor,
	inputHeightBorder,
	inputHeightInner,
	inputHeightInnerHalf,
	inputHeightInnerQuarter,
	inputHeight,
	inputHeightSm,
	inputHeightLg,
	inputTransition,
	formTextMarginTop,
	formCheckInputGutter,
	formCheckInputMarginY,
	formCheckInputMarginX,
	formCheckInlineMarginX,
	formCheckInlineInputMarginX,
	formGridGutterWidth,
	formGroupMarginBottom,
	inputGroupAddonColor,
	inputGroupAddonBg,
	inputGroupAddonBorderColor,
	customFormsTransition,
	customControlGutter,
	customControlSpacerX,
	customControlIndicatorSize,
	customControlIndicatorBg,
	customControlIndicatorBgSize,
	customControlIndicatorBoxShadow,
	customControlIndicatorBorderColor,
	customControlIndicatorBorderWidth,
	customControlIndicatorDisabledBg,
	customControlLabelDisabledColor,
	customControlIndicatorCheckedColor,
	customControlIndicatorCheckedBg,
	customControlIndicatorCheckedDisabledBg,
	customControlIndicatorCheckedBoxShadow,
	customControlIndicatorCheckedBorderColor,
	customControlIndicatorFocusBoxShadow,
	customControlIndicatorFocusBorderColor,
	customControlIndicatorActiveColor,
	customControlIndicatorActiveBg,
	customControlIndicatorActiveBoxShadow,
	customControlIndicatorActiveBorderColor,
	customCheckboxIndicatorBorderRadius,
	customCheckboxIndicatorIndeterminateBg,
	customCheckboxIndicatorIndeterminateColor,
	customCheckboxIndicatorIndeterminateBoxShadow,
	customCheckboxIndicatorIndeterminateBorderColor,
	customRadioIndicatorBorderRadius,
	customSwitchWidth,
	customSwitchIndicatorBorderRadius,
	customSwitchIndicatorSize,
	customSelectPaddingY,
	customSelectPaddingX,
	customSelectFontFamily,
	customSelectFontSize,
	customSelectHeight,
	customSelectIndicatorPadding,
	customSelectFontWeight,
	customSelectLineHeight,
	customSelectColor,
	customSelectDisabledColor,
	customSelectBg,
	customSelectDisabledBg,
	customSelectBgSize,
	customSelectIndicatorColor,
	customSelectFeedbackIconPaddingRight,
	customSelectFeedbackIconPosition,
	customSelectFeedbackIconSize,
	customSelectBorderWidth,
	customSelectBorderColor,
	customSelectBorderRadius,
	customSelectBoxShadow,
	customSelectFocusBorderColor,
	customSelectFocusWidth,
	customSelectFocusBoxShadow,
	customSelectPaddingYSm,
	customSelectPaddingXSm,
	customSelectFontSizeSm,
	customSelectHeightSm,
	customSelectPaddingYLg,
	customSelectPaddingXLg,
	customSelectFontSizeLg,
	customSelectHeightLg,
	customRangeTrackWidth,
	customRangeTrackHeight,
	customRangeTrackCursor,
	customRangeTrackBg,
	customRangeTrackBorderRadius,
	customRangeTrackBoxShadow,
	customRangeThumbWidth,
	customRangeThumbHeight,
	customRangeThumbBg,
	customRangeThumbBorder,
	customRangeThumbBorderRadius,
	customRangeThumbBoxShadow,
	customRangeThumbFocusBoxShadow,
	customRangeThumbFocusBoxShadowWidth,
	customRangeThumbActiveBg,
	customRangeThumbDisabledBg,
	customFileHeight,
	customFileHeightInner,
	customFileFocusBorderColor,
	customFileFocusBoxShadow,
	customFileDisabledBg,
	customFilePaddingY,
	customFilePaddingX,
	customFileLineHeight,
	customFileFontFamily,
	customFileFontWeight,
	customFileColor,
	customFileBg,
	customFileBorderWidth,
	customFileBorderColor,
	customFileBorderRadius,
	customFileBoxShadow,
	customFileButtonColor,
	customFileButtonBg,
	customFileText,
	formFeedbackMarginTop,
	formFeedbackFontSize,
	formFeedbackValidColor,
	formFeedbackInvalidColor,
	formFeedbackIconValidColor,
	formFeedbackIconInvalidColor,
	zindexDropdown,
	zindexSticky,
	zindexFixed,
	zindexModalBackdrop,
	zindexModal,
	zindexPopover,
	zindexTooltip,
	navLinkPaddingY,
	navLinkPaddingX,
	navLinkDisabledColor,
	navTabsBorderColor,
	navTabsBorderWidth,
	navTabsBorderRadius,
	navTabsLinkHoverBorderColor,
	navTabsLinkActiveColor,
	navTabsLinkActiveBg,
	navTabsLinkActiveBorderColor,
	navPillsBorderRadius,
	navPillsLinkActiveColor,
	navPillsLinkActiveBg,
	navDividerColor,
	navDividerMarginY,
	navbarPaddingY,
	navbarPaddingX,
	navbarNavLinkPaddingX,
	navbarBrandFontSize,
	navLinkHeight,
	navbarBrandHeight,
	navbarBrandPaddingY,
	navbarTogglerPaddingY,
	navbarTogglerPaddingX,
	navbarTogglerFontSize,
	navbarTogglerBorderRadius,
	navbarDarkColor,
	navbarDarkHoverColor,
	navbarDarkActiveColor,
	navbarDarkDisabledColor,
	navbarDarkTogglerBorderColor,
	navbarLightColor,
	navbarLightHoverColor,
	navbarLightActiveColor,
	navbarLightDisabledColor,
	navbarLightTogglerBorderColor,
	navbarLightBrandColor,
	navbarLightBrandHoverColor,
	navbarDarkBrandColor,
	navbarDarkBrandHoverColor,
	dropdownMinWidth,
	dropdownPaddingY,
	dropdownSpacer,
	dropdownFontSize,
	dropdownColor,
	dropdownBg,
	dropdownBorderColor,
	dropdownBorderRadius,
	dropdownBorderWidth,
	dropdownInnerBorderRadius,
	dropdownDividerBg,
	dropdownDividerMarginY,
	dropdownBoxShadow,
	dropdownLinkColor,
	dropdownLinkHoverColor,
	dropdownLinkHoverBg,
	dropdownLinkActiveColor,
	dropdownLinkActiveBg,
	dropdownLinkDisabledColor,
	dropdownItemPaddingY,
	dropdownItemPaddingX,
	dropdownHeaderColor,
	paginationPaddingY,
	paginationPaddingX,
	paginationPaddingYSm,
	paginationPaddingXSm,
	paginationPaddingYLg,
	paginationPaddingXLg,
	paginationLineHeight,
	paginationColor,
	paginationBg,
	paginationBorderWidth,
	paginationBorderColor,
	paginationFocusBoxShadow,
	paginationFocusOutline,
	paginationHoverColor,
	paginationHoverBg,
	paginationHoverBorderColor,
	paginationActiveColor,
	paginationActiveBg,
	paginationActiveBorderColor,
	paginationDisabledColor,
	paginationDisabledBg,
	paginationDisabledBorderColor,
	jumbotronPadding,
	jumbotronColor,
	jumbotronBg,
	cardSpacerY,
	cardSpacerX,
	cardBorderWidth,
	cardBorderRadius,
	cardBorderColor,
	cardInnerBorderRadius,
	cardCapBg,
	cardCapColor,
	cardColor,
	cardBg,
	cardImgOverlayPadding,
	cardGroupMargin,
	cardDeckMargin,
	cardColumnsCount,
	cardColumnsGap,
	cardColumnsMargin,
	tooltipFontSize,
	tooltipMaxWidth,
	tooltipColor,
	tooltipBg,
	tooltipBorderRadius,
	tooltipOpacity,
	tooltipPaddingY,
	tooltipPaddingX,
	tooltipMargin,
	tooltipArrowWidth,
	tooltipArrowHeight,
	tooltipArrowColor,
	formFeedbackTooltipPaddingY,
	formFeedbackTooltipPaddingX,
	formFeedbackTooltipFontSize,
	formFeedbackTooltipLineHeight,
	formFeedbackTooltipOpacity,
	formFeedbackTooltipBorderRadius,
	popoverFontSize,
	popoverBg,
	popoverMaxWidth,
	popoverBorderWidth,
	popoverBorderColor,
	popoverBorderRadius,
	popoverBoxShadow,
	popoverHeaderBg,
	popoverHeaderColor,
	popoverHeaderPaddingY,
	popoverHeaderPaddingX,
	popoverBodyColor,
	popoverBodyPaddingY,
	popoverBodyPaddingX,
	popoverArrowWidth,
	popoverArrowHeight,
	popoverArrowColor,
	popoverArrowOuterColor,
	toastMaxWidth,
	toastPaddingX,
	toastPaddingY,
	toastFontSize,
	toastColor,
	toastBackgroundColor,
	toastBorderWidth,
	toastBorderColor,
	toastBorderRadius,
	toastBoxShadow,
	toastHeaderColor,
	toastHeaderBackgroundColor,
	toastHeaderBorderColor,
	badgeFontSize,
	badgeFontWeight,
	badgePaddingY,
	badgePaddingX,
	badgeBorderRadius,
	badgeTransition,
	badgeFocusWidth,
	badgePillPaddingX,
	badgePillBorderRadius,
	modalInnerPadding,
	modalDialogMargin,
	modalDialogMarginYSmUp,
	modalTitleLineHeight,
	modalContentColor,
	modalContentBg,
	modalContentBorderColor,
	modalContentBorderWidth,
	modalContentBorderRadius,
	modalContentBoxShadowXs,
	modalContentBoxShadowSmUp,
	modalBackdropBg,
	modalBackdropOpacity,
	modalHeaderBorderColor,
	modalFooterBorderColor,
	modalHeaderBorderWidth,
	modalFooterBorderWidth,
	modalHeaderPaddingY,
	modalHeaderPaddingX,
	modalHeaderPadding,
	modalXl,
	modalLg,
	modalMd,
	modalSm,
	modalFadeTransform,
	modalShowTransform,
	modalTransition,
	alertPaddingY,
	alertPaddingX,
	alertMarginBottom,
	alertBorderRadius,
	alertLinkFontWeight,
	alertBorderWidth,
	alertBgLevel,
	alertBorderLevel,
	alertColorLevel,
	progressHeight,
	progressFontSize,
	progressBg,
	progressBorderRadius,
	progressBoxShadow,
	progressBarColor,
	progressBarBg,
	progressBarAnimationTiming,
	progressBarTransition,
	listGroupColor,
	listGroupBg,
	listGroupBorderColor,
	listGroupBorderWidth,
	listGroupBorderRadius,
	listGroupItemPaddingY,
	listGroupItemPaddingX,
	listGroupHoverBg,
	listGroupActiveColor,
	listGroupActiveBg,
	listGroupActiveBorderColor,
	listGroupDisabledColor,
	listGroupDisabledBg,
	listGroupActionColor,
	listGroupActionHoverColor,
	listGroupActionActiveColor,
	listGroupActionActiveBg,
	thumbnailPadding,
	thumbnailBg,
	thumbnailBorderWidth,
	thumbnailBorderColor,
	thumbnailBorderRadius,
	thumbnailBoxShadow,
	figureCaptionFontSize,
	figureCaptionColor,
	breadcrumbPaddingY,
	breadcrumbPaddingX,
	breadcrumbItemPadding,
	breadcrumbMarginBottom,
	breadcrumbBg,
	breadcrumbDividerColor,
	breadcrumbActiveColor,
	breadcrumbDivider,
	breadcrumbBorderRadius,
	spinnerWidth,
	spinnerHeight,
	spinnerBorderWidth,
	spinnerWidthSm,
	spinnerHeightSm,
	spinnerBorderWidthSm,
	closeFontSize,
	closeFontWeight,
	closeColor,
	closeTextShadow,
	codeFontSize,
	codeColor,
	kbdPaddingY,
	kbdPaddingX,
	kbdFontSize,
	kbdColor,
	kbdBg,
	preColor,
	preScrollableMaxHeight,
	displays,
	overflows,
	positions
};
